(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-column-banner-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    initBannerSliders();
  });

  function initBannerSliders() {
    const sections = document.querySelectorAll('.two-col-banner-section');
    sections.forEach((section) => {
      const slides = Array.from(section.querySelectorAll('.two-col-banner-slide'));
      const dots = Array.from(section.querySelectorAll('.banner-dot'));
      if (slides.length <= 1) return;

      let activeIndex = 0;
      let timer = null;
      const intervalSec = parseFloat(section.style.getPropertyValue('--autoplay-speed')) || 6.0;

      function updateMobileTrackHeight() {
        if (window.innerWidth <= 768) {
          let maxH = 0;
          slides.forEach((slide) => {
            const inner = slide.querySelector('.two-col-banner-inner');
            if (inner) {
              const h = inner.offsetHeight || inner.scrollHeight;
              if (h > maxH) maxH = h;
            }
          });
          const track = section.querySelector('.two-col-banner-track');
          if (track && maxH > 0) {
            track.style.height = (maxH + 6) + 'px';
          }
        } else {
          const track = section.querySelector('.two-col-banner-track');
          if (track) {
            track.style.height = '';
          }
        }
      }

      function goToSlide(targetIndex) {
        slides[activeIndex]?.classList.remove('is-active');
        dots[activeIndex]?.classList.remove('is-active');
        dots[activeIndex]?.setAttribute('aria-selected', 'false');

        activeIndex = (targetIndex + slides.length) % slides.length;

        slides[activeIndex]?.classList.add('is-active');
        dots[activeIndex]?.classList.add('is-active');
        dots[activeIndex]?.setAttribute('aria-selected', 'true');
      }

      function startAutoplay() {
        stopAutoplay();
        timer = setInterval(() => {
          goToSlide(activeIndex + 1);
        }, intervalSec * 1000);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      // Dot navigation
      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          goToSlide(idx);
          startAutoplay();
        });
      });

      // Pause interactions
      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);
      section.addEventListener('focusin', stopAutoplay);
      section.addEventListener('focusout', startAutoplay);

      // Keyboard arrow navigation
      section.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          goToSlide(activeIndex - 1);
          startAutoplay();
        } else if (e.key === 'ArrowRight') {
          goToSlide(activeIndex + 1);
          startAutoplay();
        }
      });

      // Touch swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      section.addEventListener(
        'touchstart',
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
          stopAutoplay();
        },
        { passive: true }
      );

      section.addEventListener(
        'touchend',
        (e) => {
          touchEndX = e.changedTouches[0].screenX;
          const swipeThreshold = 50;
          if (touchStartX - touchEndX > swipeThreshold) {
            goToSlide(activeIndex + 1);
          } else if (touchEndX - touchStartX > swipeThreshold) {
            goToSlide(activeIndex - 1);
          }
          startAutoplay();
        },
        { passive: true }
      );

      // Initialize responsive track height calculation
      updateMobileTrackHeight();
      window.addEventListener('resize', updateMobileTrackHeight, { passive: true });
      window.addEventListener('load', updateMobileTrackHeight, { passive: true });

      slides.forEach((slide) => {
        const img = slide.querySelector('img');
        if (img) {
          if (img.complete) {
            updateMobileTrackHeight();
          } else {
            img.addEventListener('load', updateMobileTrackHeight, { once: true });
          }
        }
      });

      startAutoplay();
    });
  }

  // Shopify Theme Editor live select hooks
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target;
    if (!slide || !slide.classList.contains('two-col-banner-slide')) return;
    const parentSection = slide.closest('.two-col-banner-section');
    if (!parentSection) return;

    const slides = Array.from(parentSection.querySelectorAll('.two-col-banner-slide'));
    const dots = Array.from(parentSection.querySelectorAll('.banner-dot'));
    const index = slides.indexOf(slide);

    slides.forEach((s) => s.classList.remove('is-active'));
    dots.forEach((d) => {
      d.classList.remove('is-active');
      d.setAttribute('aria-selected', 'false');
    });

    slide.classList.add('is-active');
    if (dots[index]) {
      dots[index].classList.add('is-active');
      dots[index].setAttribute('aria-selected', 'true');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
